import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { CloudtrailService } from '../../service';

export type LogsIntegrationConfig = typeof LogsIntegrationConfig._.Config;

export const LogsIntegrationConfig = IntegrationConfig.make({
  service: CloudtrailService,
  name: Integration_Handler_Names_Enum.LogsIntegration,
  configSchema: z.object({}),
});
